const context = Symbol().toString()

const mixin =  {
  inject: [context],
  computed: {
    next: {
      get() {
        return this[context].next.get()
      },
      set(v) {
        this[context].next.set(v)
      }
    },
    prev: {
      get() {
        return this[context].prev.get()
      },
      set(v) {
        this[context].prev.set(v)
      }
    },
  }
}


export default {context, mixin}